import { Toaster } from 'react-hot-toast';

const CustomToast = () => {
  return (
    <Toaster
      position="top-center"
      reverseOrder={false}
      toastOptions={{
        duration: 1500, 
      }}
    />
  );
};

export default CustomToast;